class NumberFormatter {
    static shared = new NumberFormatter();

    constructor() {
        this.numberFormatter = new Intl.NumberFormat('bs-BA', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
            useGrouping: true,
        });
    }

    n(number) {
        if (typeof number === 'string') {
            number = parseFloat(number.replace(',', '.'));
        }

        const num = Number(number) || 0;

        return this.numberFormatter.format(num)
            .replace(/\./g, 'TEMP')    // temporarily replace dots
            .replace(/,/g, '.')        // replace commas with dots
            .replace(/TEMP/g, ',');    // replace temp with commas
    }
}

export default NumberFormatter;